"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductIdentificationPref = getProductIdentificationPref;
exports.getProfile = getProfile;
exports.getUserFacilities = getUserFacilities;
exports.logout = logout;
exports.setProductIdentificationPref = setProductIdentificationPref;

var _api = _interopRequireWildcard(require("../../api"));

var _user = require("../../mappings/user");

var _util = require("../../util");

var _nodeJsonTransform = require("node-json-transform");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function getProfile() {
  return _getProfile.apply(this, arguments);
}

function _getProfile() {
  _getProfile = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var resp, user;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return (0, _api["default"])({
              url: "user-profile",
              method: "get"
            });

          case 3:
            resp = _context.sent;

            if (!(resp.status === 200 && !(0, _util.hasError)(resp))) {
              _context.next = 9;
              break;
            }

            user = (0, _nodeJsonTransform.transform)(resp.data, _user.userProfileTransformRule);
            return _context.abrupt("return", Promise.resolve(user));

          case 9:
            return _context.abrupt("return", Promise.reject({
              code: 'error',
              message: 'Something went wrong',
              serverResponse: 'Failed to fetch user profile information'
            }));

          case 10:
            _context.next = 15;
            break;

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", Promise.reject({
              code: 'error',
              message: 'Something went wrong',
              serverResponse: _context.t0
            }));

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  }));
  return _getProfile.apply(this, arguments);
}

function setProductIdentificationPref(_x, _x2) {
  return _setProductIdentificationPref.apply(this, arguments);
}

function _setProductIdentificationPref() {
  _setProductIdentificationPref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(eComStoreId, productIdentificationPref) {
    var fromDate, payload, resp, params, _resp;

    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            payload = {
              "inputFields": {
                "productStoreId": eComStoreId,
                "settingTypeEnumId": "PRDT_IDEN_PREF"
              },
              "filterByDate": 'Y',
              "entityName": "ProductStoreSetting",
              "fieldList": ["fromDate", "productStoreId"],
              "viewSize": 1
            };
            _context2.prev = 1;
            _context2.next = 4;
            return (0, _api["default"])({
              url: "performFind",
              method: "get",
              params: payload,
              cache: true
            });

          case 4:
            resp = _context2.sent;

            if (!(0, _util.hasError)(resp)) {
              fromDate = resp.data.docs[0].fromDate;
            }

            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2["catch"](1);
            console.error(_context2.t0);

          case 11:
            if (fromDate) {
              _context2.next = 13;
              break;
            }

            return _context2.abrupt("return", Promise.reject('fromDate information is missing'));

          case 13:
            params = {
              "fromDate": fromDate,
              "productStoreId": eComStoreId,
              "settingTypeEnumId": "PRDT_IDEN_PREF",
              "settingValue": JSON.stringify(productIdentificationPref)
            };
            _context2.prev = 14;
            _context2.next = 17;
            return (0, _api["default"])({
              url: "service/updateProductStoreSetting",
              method: "post",
              data: params
            });

          case 17:
            _resp = _context2.sent;

            if ((0, _util.hasError)(_resp)) {
              _context2.next = 22;
              break;
            }

            return _context2.abrupt("return", Promise.resolve(productIdentificationPref));

          case 22:
            return _context2.abrupt("return", Promise.reject(_resp));

          case 23:
            _context2.next = 28;
            break;

          case 25:
            _context2.prev = 25;
            _context2.t1 = _context2["catch"](14);
            return _context2.abrupt("return", Promise.reject(_context2.t1));

          case 28:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 8], [14, 25]]);
  }));
  return _setProductIdentificationPref.apply(this, arguments);
}

function createProductIdentificationPref(_x3) {
  return _createProductIdentificationPref.apply(this, arguments);
}

function _createProductIdentificationPref() {
  _createProductIdentificationPref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(eComStoreId) {
    var prefValue, params;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            prefValue = {
              primaryId: 'productId',
              secondaryId: ''
            };
            params = {
              "fromDate": Date.now(),
              "productStoreId": eComStoreId,
              "settingTypeEnumId": "PRDT_IDEN_PREF",
              "settingValue": JSON.stringify(prefValue)
            };
            _context3.prev = 2;
            _context3.next = 5;
            return (0, _api["default"])({
              url: "service/createProductStoreSetting",
              method: "post",
              data: params
            });

          case 5:
            _context3.next = 10;
            break;

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](2);
            console.error(_context3.t0);

          case 10:
            return _context3.abrupt("return", prefValue);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 7]]);
  }));
  return _createProductIdentificationPref.apply(this, arguments);
}

function getProductIdentificationPref(_x4) {
  return _getProductIdentificationPref.apply(this, arguments);
}

function _getProductIdentificationPref() {
  _getProductIdentificationPref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(eComStoreId) {
    var productIdentifications, payload, resp, respValue;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            productIdentifications = {
              'primaryId': 'productId',
              'secondaryId': ''
            };
            payload = {
              "inputFields": {
                "productStoreId": eComStoreId,
                "settingTypeEnumId": "PRDT_IDEN_PREF"
              },
              "filterByDate": 'Y',
              "entityName": "ProductStoreSetting",
              "fieldList": ["settingValue", "fromDate"],
              "viewSize": 1
            };
            _context4.prev = 2;
            _context4.next = 5;
            return (0, _api["default"])({
              url: "performFind",
              method: "get",
              params: payload,
              cache: true
            });

          case 5:
            resp = _context4.sent;

            if (!(!(0, _util.hasError)(resp) && resp.data.docs[0].settingValue)) {
              _context4.next = 12;
              break;
            }

            respValue = JSON.parse(resp.data.docs[0].settingValue);
            productIdentifications['primaryId'] = respValue['primaryId'];
            productIdentifications['secondaryId'] = respValue['secondaryId'];
            _context4.next = 15;
            break;

          case 12:
            if (!(resp.data.error === "No record found")) {
              _context4.next = 15;
              break;
            }

            _context4.next = 15;
            return createProductIdentificationPref(eComStoreId);

          case 15:
            _context4.next = 20;
            break;

          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4["catch"](2);
            console.error(_context4.t0);

          case 20:
            return _context4.abrupt("return", productIdentifications);

          case 21:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[2, 17]]);
  }));
  return _getProductIdentificationPref.apply(this, arguments);
}

function logout() {
  return _logout.apply(this, arguments);
}

function _logout() {
  _logout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
    var resp;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return (0, _api["default"])({
              url: "logout",
              method: "get"
            });

          case 3:
            resp = _context5.sent;

            if (!(resp.status != 200)) {
              _context5.next = 6;
              break;
            }

            throw resp.data;

          case 6:
            return _context5.abrupt("return", Promise.resolve(resp.data));

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", Promise.reject(_context5.t0));

          case 12:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 9]]);
  }));
  return _logout.apply(this, arguments);
}

function getUserFacilities(_x5, _x6, _x7, _x8) {
  return _getUserFacilities.apply(this, arguments);
}

function _getUserFacilities() {
  _getUserFacilities = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(token, baseURL, partyId, facilityGroupId) {
    var isAdminUser,
        params,
        resp,
        _args6 = arguments;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            isAdminUser = _args6.length > 4 && _args6[4] !== undefined ? _args6[4] : false;
            _context6.prev = 1;
            params = {
              "inputFields": {},
              "filterByDate": "Y",
              "viewSize": 200,
              "distinct": "Y",
              "noConditionFind": "Y"
            };

            if (facilityGroupId) {
              params.entityName = "FacilityGroupAndParty";
              params.fieldList = ["facilityId", "facilityName", "sequenceNum"];
              params.fromDateName = "FGMFromDate";
              params.thruDateName = "FGMThruDate";
              params.orderBy = "sequenceNum ASC | facilityName ASC";
              params.inputFields["facilityGroupId"] = facilityGroupId;
            } else {
              params.entityName = "FacilityAndParty";
              params.fieldList = ["facilityId", "facilityName"];
              params.inputFields["facilityParentTypeId"] = "VIRTUAL_FACILITY";
              params.inputFields["facilityParentTypeId_op"] = "notEqual";
              params.orderBy = "facilityName ASC";
            }

            if (!isAdminUser) {
              params.inputFields["partyId"] = partyId;
            }

            resp = {};
            _context6.next = 8;
            return (0, _api.client)({
              url: "performFind",
              method: "get",
              baseURL: baseURL,
              params: params,
              headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json'
              }
            });

          case 8:
            resp = _context6.sent;

            if (!(resp.status === 200 && !(0, _util.hasError)(resp))) {
              _context6.next = 13;
              break;
            }

            return _context6.abrupt("return", Promise.resolve(resp.data.docs));

          case 13:
            return _context6.abrupt("return", Promise.reject({
              code: 'error',
              message: 'Something went wrong',
              serverResponse: 'Failed to fetch user facilities'
            }));

          case 14:
            _context6.next = 19;
            break;

          case 16:
            _context6.prev = 16;
            _context6.t0 = _context6["catch"](1);
            return _context6.abrupt("return", Promise.reject({
              code: 'error',
              message: 'Something went wrong',
              serverResponse: _context6.t0
            }));

          case 19:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[1, 16]]);
  }));
  return _getUserFacilities.apply(this, arguments);
}